<template>
  <div>
    <md-dialog :md-close-on-esc="false"
               :md-click-outside-to-close="false"
               :md-active.sync="isSettingsOpened"
    >
      <md-dialog-title>{{ i18n.set_tfa_enable() }}</md-dialog-title>

      <div class="app__dialog-inner">
        <p class="tfa-settings__explain">{{ i18n.set_tfa_scan_the_qr_code() }}</p>
        <div class="tfa-settings__qr-outer" v-if="inputMode === INPUT_MODES.qr">
          <qrcode class="tfa-settings__qr-code"
                  :text="factor.qr"
                  :size="225"
                  color="#3f4244"
          />
        </div>
        <p class="tfa-settings__explain-additional">{{ i18n.set_or_manually_enter() }}</p>
        <clipboard-field
          class="tfa-settings__copy-secret"
          :value="factor.secret"
          :label="i18n.lbl_secret()"
        />
      </div>

      <md-dialog-actions class="md-layout md-alignment-center-right">
        <md-button @click="updateFactor" class="md-primary">{{ i18n.lbl_confirm() }}</md-button>
      </md-dialog-actions>

    </md-dialog>
  </div>
</template>

<script>
  import ClipboardField from '@com/fields/ClipboardField'

  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { factorsService } from '@api/factors.service'
  import { i18n } from '@js/i18n'

  import Qrcode from 'vue-qrcode-component'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  const ENABLED_FACTOR_PRIORITY = 1

  const INPUT_MODES = {
    qr: 'qr',
    manual: 'manual'
  }

  export default {
    name: 'auth-tfa',
    components: { Qrcode, ClipboardField },
    data: _ => ({
      inputMode: INPUT_MODES.qr,
      isSettingsOpened: false,
      factor: {
        id: -1,
        secret: null,
        qr: null
      },
      i18n,
      INPUT_MODES
    }),
    methods: {
      async checkState () {
        let factors = []
        factors = (await factorsService.loadFactors())
          .data()
          .filter(factor => factor.type === 'totp')

        const disabledFactors = factors
          .filter(factor => factor.attributes.priority === 0)
          .map(factor => factor.id)

        if (disabledFactors.length > 0) {
          await Promise.all(disabledFactors.map(id => factorsService.deleteFactor(id)))
          return
        }

        const data = (await factorsService.checkTFAEnabled()).data()

        if (data.tfa_enabled && (!factors.length || disabledFactors.length)) {
          await this.createFactor()
        } else {
          this.$emit('enterApplication')
        }
      },
      async createFactor () {
        if (this.factor.id !== -1) {
          await factorsService.deleteFactor(this.factor.id)
        }
        const factor = await factorsService.createFactor('totp')
        this.factor.secret = factor.attribute('secret')
        this.factor.qr = factor.attribute('seed')
        this.factor.id = factor.data('id')
        this.isSettingsOpened = true
      },
      async updateFactor () {
        try {
          await factorsService.updateFactor(
            this.factor.id,
            ENABLED_FACTOR_PRIORITY
          )
          this.isSettingsOpened = false
          this.$emit('enterApplication')
        } catch (error) {
          if (error.showBanner) {
            error.showBanner(i18n.unexpected_error())
            return
          }
          EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error())
        }
      },
      async deleteFactor () {
        try {
          await factorsService.deleteFactor(this.factor.id)
        } catch (error) {
          if (error.showBanner) {
            error.showBanner(i18n.unexpected_error())
            return
          }
          EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error())
        }
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountBlocked
      ])
    }
  }
</script>

<style lang="scss" scoped>
  @import './../app/settings/security/settings.scss';

  .md-dialog {
    width: 25rem;
  }

  .tfa-settings__qr-outer {
    max-width: 225px;
    margin: 0 auto 20px;
  }

  .tfa-settings__explain {
    margin-bottom: 20px;
  }

  .tfa-settings__explain-additional,
  .tfa-settings__copy-secret {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/auth/TwoFA.vue